// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".invalidInput[data-v-7af4028b],\n.groupIdFormat[data-v-7af4028b] {\n  text-align: left;\n  padding: 0.75rem 1rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
